var m = Object.defineProperty;
var y = (l, i, e) => i in l ? m(l, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[i] = e;
var a = (l, i, e) => (y(l, typeof i != "symbol" ? i + "" : i, e), e);
import { Chart as c, registerables as C } from "chart.js";
import P from "chartjs-plugin-zoom";
import { CrosshairPlugin as v } from "chartjs-plugin-crosshair";
import { config as D, elevation as b, math as w } from "@maptiler/sdk";
const u = 3.28084, M = 621371e-9;
function x(l) {
  const i = [];
  function e(o) {
    (o.type === "LineString" || o.type === "MultiLineString") && i.push(o);
  }
  function s(o) {
    o.geometry && e(o.geometry);
  }
  function n(o) {
    for (const d of o.features)
      d.type === "Feature" ? s(d) : d.type === "FeatureCollection" && n(d);
  }
  return l.type === "Feature" ? s(l) : l.type === "FeatureCollection" ? n(l) : e(l), i;
}
function A(l) {
  const i = x(l), e = [];
  for (let s = 0; s < i.length; s += 1) {
    const n = i[s];
    n.type === "LineString" ? e.push(n.coordinates) : n.type === "MultiLineString" && e.push(n.coordinates.flat());
  }
  return e.flat();
}
const E = {
  backgroundColor: null,
  unit: "metric",
  fontSize: 12,
  forceComputeElevation: !1,
  displayElevationLabels: !0,
  displayDistanceLabels: !0,
  displayUnits: !0,
  labelColor: "#0009",
  profileLineColor: "#66ccff",
  profileLineWidth: 1.5,
  profileBackgroundColor: "#66ccff22",
  displayTooltip: !0,
  tooltipTextColor: "#fff",
  tooltipBackgroundColor: "#000A",
  tooltipDisplayDistance: !0,
  tooltipDisplayElevation: !0,
  tooltipDisplayDPlus: !0,
  tooltipDisplayGrade: !0,
  displayDistanceGrid: !1,
  displayElevationGrid: !0,
  distanceGridColor: "#0001",
  elevationGridColor: "#0001",
  displayCrosshair: !0,
  crosshairColor: "#0005",
  onChangeView: null,
  paddingTop: 30,
  paddingBottom: 10,
  paddingLeft: 10,
  paddingRight: 10,
  onClick: null,
  onMove: null
};
class j {
  constructor(i, e, s = {}) {
    a(this, "canvas");
    a(this, "settings");
    a(this, "chart");
    a(this, "elevatedPositions", []);
    a(this, "elevatedPositionsAdjustedUnit", []);
    a(this, "cumulatedDistance", []);
    a(this, "cumulatedDistanceAdjustedUnit", []);
    a(this, "cumulatedDPlus", []);
    a(this, "grade", []);
    D.apiKey = e;
    const n = typeof i == "string" ? document.getElementById(i) : i;
    if (!n)
      throw new Error("The container does not exist.");
    this.canvas = document.createElement("canvas"), n.appendChild(this.canvas), c.register(...C), c.register(P), c.register(v), this.settings = {
      ...E,
      ...s
    };
    const o = this.settings.unit === "imperial" ? "mi" : "km", d = this.settings.unit === "imperial" ? "ft" : "m";
    if (c.defaults.font.size = this.settings.fontSize, this.chart = new c(this.canvas, {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            label: "Elevation",
            data: [],
            pointRadius: 0,
            fill: !!this.settings.profileBackgroundColor,
            borderColor: this.settings.profileLineColor ?? "#0000",
            backgroundColor: this.settings.profileBackgroundColor ?? "#0000",
            tension: 0.1,
            spanGaps: !0,
            // If line color is null, the line width is set to 0
            borderWidth: this.settings.profileLineColor ? this.settings.profileLineWidth : 0
            // segment: {
            //   borderColor: (ctx: ScriptableLineSegmentContext) => {
            //     const grade = ~~(this.grade[ctx.p0DataIndex]);
            //     if (grade < 1) return gradeColor[0];
            //     if (grade > 10) return gradeColor[11];
            //     return gradeColor[grade];
            //   }
            // }
          }
        ]
      },
      options: {
        layout: {
          padding: {
            left: this.settings.paddingLeft,
            right: this.settings.paddingRight,
            bottom: this.settings.paddingBottom,
            top: this.settings.paddingTop
          }
        },
        onClick: (t, r) => {
          if (typeof this.settings.onClick == "function")
            try {
              const h = r[0].index;
              this.settings.onClick.apply(this, [
                {
                  position: this.elevatedPositionsAdjustedUnit[h],
                  distance: this.cumulatedDistanceAdjustedUnit[h],
                  dPlus: this.cumulatedDPlus[h],
                  gradePercent: this.grade[h]
                }
              ]);
            } catch {
            }
        },
        onHover: (t, r) => {
          if (typeof this.settings.onMove == "function")
            try {
              const h = r[0].index;
              this.settings.onMove.apply(this, [
                {
                  position: this.elevatedPositionsAdjustedUnit[h],
                  distance: this.cumulatedDistanceAdjustedUnit[h],
                  dPlus: this.cumulatedDPlus[h],
                  gradePercent: this.grade[h]
                }
              ]);
            } catch {
            }
        },
        animation: !1,
        maintainAspectRatio: !1,
        scales: {
          x: {
            min: 0,
            max: 0,
            type: "linear",
            grid: {
              display: this.settings.displayDistanceGrid,
              color: this.settings.distanceGridColor,
              drawTicks: !1
            },
            ticks: {
              align: "inner",
              display: this.settings.displayDistanceLabels,
              color: this.settings.labelColor,
              callback: (t) => {
                const r = ~~(t * 100) / 100;
                return this.settings.displayUnits ? `${r} ${o}` : r;
              }
            }
          },
          y: {
            min: 0,
            max: 0,
            type: "linear",
            ticks: {
              mirror: !0,
              align: "end",
              display: this.settings.displayElevationLabels,
              color: this.settings.labelColor,
              callback: (t) => {
                const r = ~~(t * 100) / 100;
                return this.settings.displayUnits ? `${r} ${d}` : r;
              }
            },
            grid: {
              display: this.settings.displayElevationGrid,
              color: this.settings.elevationGridColor,
              drawTicks: !1
            }
          }
        },
        interaction: {
          intersect: !1,
          mode: "index"
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: !0
              },
              pinch: {
                enabled: !0
              },
              mode: "x"
            },
            pan: {
              enabled: !0,
              mode: "x"
            },
            limits: {
              x: {
                min: "original",
                max: "original"
              }
            }
          },
          title: {
            display: !1
          },
          legend: {
            display: !1
          },
          tooltip: {
            enabled: this.settings.displayTooltip,
            yAlign: "center",
            cornerRadius: 3,
            displayColors: !1,
            backgroundColor: this.settings.tooltipBackgroundColor,
            bodyColor: this.settings.tooltipTextColor,
            callbacks: {
              title: () => "",
              label: (t) => {
                const r = [];
                return this.settings.tooltipDisplayDistance && r.push(
                  `Distance: ${this.cumulatedDistanceAdjustedUnit[t.dataIndex].toFixed(4)} ${o}`
                ), this.settings.tooltipDisplayElevation && r.push(
                  `Elevation: ${this.elevatedPositionsAdjustedUnit[t.dataIndex][2].toFixed(2)} ${d}`
                ), this.settings.tooltipDisplayDPlus && r.push(
                  `D+: ${this.cumulatedDPlus[t.dataIndex].toFixed(
                    0
                  )} ${d}`
                ), this.settings.tooltipDisplayGrade && r.push(
                  `Grade: ${this.grade[t.dataIndex].toFixed(1)}%`
                ), r;
              }
            }
          },
          // The crosshair plugin does not have types
          // @ts-ignore
          crosshair: {
            zoom: {
              enabled: !1
            },
            line: {
              color: this.settings.displayCrosshair ? this.settings.crosshairColor : "#0000",
              width: 1
            }
          }
        }
      },
      plugins: [
        {
          id: "customZoomEvent",
          afterDataLimits: () => {
            if (typeof this.settings.onChangeView == "function")
              try {
                this.settings.onChangeView.apply(this, [
                  this.createWindowExtractLineString()
                ]);
              } catch {
              }
          }
        }
      ]
    }), this.settings.displayTooltip) {
      let t = !1;
      this.chart.canvas.addEventListener("mousedown", () => {
        t = !0;
      }), this.chart.canvas.addEventListener("mousemove", () => {
        t && this.chart.options.plugins && this.chart.options.plugins.tooltip && (this.chart.options.plugins.tooltip.enabled = !1, this.chart.update());
      }), window.addEventListener("mouseup", () => {
        this.chart.options.plugins && this.chart.options.plugins.tooltip && (this.chart.options.plugins.tooltip.enabled = !0, this.chart.update(), t = !1);
      });
    }
  }
  createWindowExtractLineString() {
    const i = this.chart.scales.x.min, e = this.chart.scales.x.max, s = this.cumulatedDistanceAdjustedUnit, n = s.length;
    let o = 0, d = n - 1;
    for (let t = 0; t < n; t += 1)
      if (s[t] >= i) {
        o = t;
        break;
      }
    for (let t = n - 1; t >= o; t -= 1)
      if (s[t] <= e) {
        d = t;
        break;
      }
    return this.createExtractLineString(o, d);
  }
  createExtractLineString(i, e) {
    return {
      type: "LineString",
      coordinates: this.elevatedPositions.slice(
        i,
        e
      )
    };
  }
  async setData(i) {
    const e = Array.isArray(i) ? i : A(i);
    this.settings.forceComputeElevation || e.some((t) => t.length === 2) ? this.elevatedPositions = await b.batch(e, {
      smoothingKernelSize: e.length / 100
    }) : this.elevatedPositions = e, this.cumulatedDistance = w.haversineCumulatedDistanceWgs84(
      this.elevatedPositions
    ), this.cumulatedDPlus = [], this.grade = [];
    let s = 0;
    for (let t = 0; t < this.elevatedPositions.length; t += 1) {
      const r = this.elevatedPositions[t][2];
      if (t > 1) {
        const h = this.elevatedPositions[t - 1][2], p = r - h, f = this.cumulatedDistance[t] - this.cumulatedDistance[t - 1];
        s += Math.max(0, p), this.cumulatedDPlus.push(s), this.grade.push(p / f * 1e3 / 10);
      }
    }
    this.grade.push(0), this.cumulatedDPlus.push(s), this.settings.unit === "imperial" ? (this.cumulatedDistanceAdjustedUnit = this.cumulatedDistance.map(
      (t) => t * M
    ), this.elevatedPositionsAdjustedUnit = this.elevatedPositions.map((t) => [
      t[0],
      t[1],
      t[2] * u
    ]), this.cumulatedDPlus = this.cumulatedDPlus.map(
      (t) => t * u
    )) : (this.cumulatedDistanceAdjustedUnit = this.cumulatedDistance.map(
      (t) => t / 1e3
    ), this.elevatedPositionsAdjustedUnit = this.elevatedPositions);
    let n = 1 / 0, o = -1 / 0;
    for (let t = 0; t < this.elevatedPositionsAdjustedUnit.length; t += 1)
      this.elevatedPositionsAdjustedUnit[t][2] < n && (n = this.elevatedPositionsAdjustedUnit[t][2]), this.elevatedPositionsAdjustedUnit[t][2] > o && (o = this.elevatedPositionsAdjustedUnit[t][2]);
    const d = (o - n) * 0.1;
    this.chart.data.labels = this.cumulatedDistanceAdjustedUnit, this.chart.data.datasets[0].data = this.elevatedPositionsAdjustedUnit.map(
      (t) => t[2]
    ), this.chart.options.scales && this.chart.options.scales.x && this.chart.options.scales.y && (this.chart.options.scales.x.min = this.cumulatedDistanceAdjustedUnit[0], this.chart.options.scales.x.max = this.cumulatedDistanceAdjustedUnit[this.cumulatedDistanceAdjustedUnit.length - 1], this.chart.options.scales.y.min = n - d, this.chart.options.scales.y.max = o + d), this.chart.update();
  }
}
function I(l) {
  return /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi.test(l);
}
const g = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiPjxwYXRoIGQ9Im04Mi0xMjAgMjU4LTM2MGgyMDJsMjk4LTM0OHY3MDhIODJabTcwLTIzMy02NC00NiAxNzItMjQxaDIwMmwxODgtMjE5IDYwIDUyLTIxMiAyNDdIMzAwTDE1Mi0zNTNabTg2IDE1M2g1MjJ2LTQxMkw1NzgtNDAwSDM4MEwyMzgtMjAwWm01MjIgMFoiIHN0eWxlPSJmaWxsOnJnYig2OCw3Myw4Mik7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PC9zdmc+", L = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiPjxwYXRoIGQ9Im04Mi0xMjAgMjU4LTM2MGgyMDJsMjk4LTM0OHY3MDhIODJabTcwLTIzMy02NC00NiAxNzItMjQxaDIwMmwxODgtMjE5IDYwIDUyLTIxMiAyNDdIMzAwTDE1Mi0zNTNaIiBzdHlsZT0iZmlsbDpyZ2IoNjgsNzMsODIpO2ZpbGwtcnVsZTpub256ZXJvOyIvPjwvc3ZnPg==";
class B {
  constructor(i = {}) {
    a(this, "map");
    a(this, "buttonContainer");
    a(this, "toggleButton");
    a(this, "isProfileShown", !1);
    a(this, "iconSpan");
    a(this, "profileContainer");
    a(this, "settings");
    a(this, "data", null);
    a(this, "elevationProfileChart");
    a(this, "getDefaultPosition");
    if (typeof window > "u")
      throw new Error("This pluggin must be mounted client-side");
    this.settings = { ...i };
  }
  getContainer() {
    return this.profileContainer;
  }
  onAdd(i) {
    this.map = i, this.buttonContainer = document.createElement("div"), this.settings.showButton === !1 && this.buttonContainer.style.setProperty("display", "none"), this.buttonContainer.classList.add(
      "maplibregl-ctrl",
      "maplibregl-ctrl-group"
    ), this.toggleButton = document.createElement("button"), this.buttonContainer.appendChild(this.toggleButton), this.iconSpan = document.createElement("span"), this.iconSpan.classList.add("maplibregl-ctrl-icon"), this.toggleButton.appendChild(this.iconSpan), this.iconSpan.style.setProperty(
      "background-image",
      `url(${g})`
    ), this.toggleButton.addEventListener("click", this.toggleProfile.bind(this));
    const e = i.getContainer(), s = this.settings.size ?? "30%";
    if (this.settings.container) {
      const n = typeof this.settings.container == "string" ? document.getElementById(this.settings.container) : this.settings.container;
      if (!n)
        throw new Error("The provided container is invalid");
      this.profileContainer = n;
    } else
      this.profileContainer = document.createElement("div"), this.profileContainer.style.setProperty("display", "none"), this.settings.containerClass || (this.profileContainer.style.setProperty(
        "background-color",
        this.settings.backgroundColor ?? "white"
      ), this.profileContainer.style.setProperty("position", "absolute"), this.settings.position === "bottom" || !this.settings.position ? (this.settings.paddingBottom = this.settings.paddingBottom ?? 35, this.profileContainer.style.setProperty("width", "100%"), this.profileContainer.style.setProperty("height", s), this.profileContainer.style.setProperty("bottom", "0")) : this.settings.position === "top" ? (this.profileContainer.style.setProperty("width", "100%"), this.profileContainer.style.setProperty("height", s), this.profileContainer.style.setProperty("top", "0")) : this.settings.position === "left" ? (this.settings.paddingBottom = this.settings.paddingBottom ?? 35, this.profileContainer.style.setProperty("width", s), this.profileContainer.style.setProperty("height", "100%"), this.profileContainer.style.setProperty("left", "0")) : this.settings.position === "right" && (this.settings.paddingBottom = this.settings.paddingBottom ?? 35, this.profileContainer.style.setProperty("width", s), this.profileContainer.style.setProperty("height", "100%"), this.profileContainer.style.setProperty("right", "0"))), e.appendChild(this.profileContainer);
    return this.settings.containerClass && this.profileContainer.classList.add(this.settings.containerClass), this.elevationProfileChart = new j(
      this.profileContainer,
      i.getSdkConfig().apiKey,
      this.settings
    ), this.settings.visible && this.showProfile(), this.buttonContainer;
  }
  toggleProfile() {
    this.profileContainer && (this.isProfileShown ? this.hideProfile() : this.showProfile());
  }
  showProfile() {
    var i, e;
    (i = this.profileContainer) == null || i.style.setProperty("display", "inherit"), (e = this.iconSpan) == null || e.style.setProperty(
      "background-image",
      `url(${L})`
    ), this.isProfileShown = !0;
  }
  hideProfile() {
    var i, e;
    (i = this.profileContainer) == null || i.style.setProperty("display", "none"), (e = this.iconSpan) == null || e.style.setProperty(
      "background-image",
      `url(${g})`
    ), this.isProfileShown = !1;
  }
  onRemove() {
    var i;
    (i = this.buttonContainer) != null && i.parentNode && this.buttonContainer.parentNode.removeChild(this.buttonContainer), this.map = void 0, this.buttonContainer = void 0, this.toggleButton = void 0, this.isProfileShown = !1;
  }
  async setData(i) {
    if (!this.map || !this.elevationProfileChart)
      throw new Error(
        "The Elevation Profile Control needs to be mounted on a map instance before setting any data."
      );
    if (typeof i == "string") {
      const e = I(i) ? `https://api.maptiler.com/data/${i}/features.json?key=${this.map.getSdkConfig().apiKey}` : i, s = await fetch(e);
      this.data = await s.json();
    } else
      this.data = i;
    this.data && this.elevationProfileChart.setData(this.data);
  }
}
export {
  j as ElevationProfile,
  B as ElevationProfileControl
};
